import {createSlice} from "@reduxjs/toolkit";
import {getProfileSuccess} from "store/reducer/user/profile/reducer";
import {keyBy} from "lodash";
import {ReducerStatuses} from "services/utils/utils";

export const initialState = {
    add: {
        status: ReducerStatuses.IDLE,
        error: ""
    },
    remove: {
        status: ReducerStatuses.IDLE,
        error: ""
    },
    cards: {}
}

const slice = createSlice({
    name: "paymentCards",
    initialState,
    reducers: {
        addNewPaymentMethodStart: (state) => {
            state.add.status = ReducerStatuses.LOADING;
        },
        addNewPaymentMethodFailure: (state, {payload}) => {
            state.add.status = ReducerStatuses.ERROR;
            state.add.error = payload;
        },
        addNewPaymentMethodSuccess: (state) => {
            state.add.status = ReducerStatuses.SUCCESS;
        },
        deletePaymentMethodStart: (state, {payload}) => {
            state.remove.status = ReducerStatuses.LOADING;
            state.cards[payload.id].deleting = true;
        },
        deletePaymentMethodFailure: (state, {payload}) => {
            state.remove.status = ReducerStatuses.ERROR;
            state.remove.error = payload.error;
            state.cards[payload.id].deleting = false;
        },
        deletePaymentMethodSuccess: (state) => {
            state.remove.status = ReducerStatuses.SUCCESS;
        }
    },
    extraReducers: {
        [getProfileSuccess]: (state, {payload}) => {
            state.cards = {
                ...keyBy(payload.cards, "stripe_id")
            }
        }
    }
});
const {reducer, actions} = slice;
export const {
    addNewPaymentMethodFailure, addNewPaymentMethodStart, addNewPaymentMethodSuccess, deletePaymentMethodFailure, deletePaymentMethodStart, deletePaymentMethodSuccess
} = actions;
export default reducer;